import { Component } from '@angular/core';

@Component({
  standalone: true,
  template: `<div class="container py-5"><h2>404</h2><p class="text-secondary">Route not found.</p></div>`,
})
export class NotFoundPage {}
